/**
 * Written by Linh
 */

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContinueButton from "../../assets/buttons/Continue_Button.png";
import ContinueButtonHovered from "../../assets/buttons/Continue_Button_Hovered.png";
import "../../assets/styles/popup-styles.css";
import { playAudio, stopAudio } from "../../ultilities/redux.audioSlice.js";

// correct popup shown when user clicks on correct answer
export function CorrectPopUp({
  isSpanish,
  message,
  setShowPopup,
  setSelectorReturnValue,
}) {
  const dispatch = useDispatch(); // for vo handle
  const playing = useSelector((state) => state.audio.playing);

  const [isContinueBtnHovered, setContinueBtnHovered] = useState(false);

  // handle hovers
  const handleContinueBtnHover = () => {
    setContinueBtnHovered(true);
  };
  const handleContinueBtnLeave = () => {
    setContinueBtnHovered(false);
  };

  // when click to next btn
  function handleClick() {
    if (playing) {
      // audio handles
      dispatch(stopAudio()); // stop the feedback vo to move on the next slide
      dispatch(playAudio({ id: "slideVO" })); // continue playing slide vo
    }

    setShowPopup(false);
    setSelectorReturnValue("correctAnswer");
  }

  return (
    <div className="popup-bg">
      <div className="popup-rectangle">
        <h3 className="popup-title">
          {isSpanish ? "¡Eso es Correcto!" : "That is Correct!"}
        </h3>
        <p className="popup-text">{message}</p>
      </div>
      <img
        src={isContinueBtnHovered ? ContinueButtonHovered : ContinueButton}
        className="continue-btn"
        alt="Continue button"
        onClick={handleClick}
        onMouseEnter={handleContinueBtnHover}
        onMouseLeave={handleContinueBtnLeave}
      />
    </div>
  );
}

// incorrect popup shown when user clicks on wrong answer
export function IncorrectPopUp({ isSpanish, setShowPopup }) {
  const dispatch = useDispatch(); // for vo handle
  const playing = useSelector((state) => state.audio.playing);
  const [isContinueBtnHovered, setContinueBtnHovered] = useState(false);

  function handleClick() {
    setShowPopup(false);

    if (playing) {
      // audio handles
      dispatch(stopAudio()); // stop the feedback vo to move on the next slide
      dispatch(playAudio({ id: "slideVO" })); // continue playing slide vo
    }
  }

  // handle hovers
  const handleContinueBtnHover = () => {
    setContinueBtnHovered(true);
  };
  const handleContinueBtnLeave = () => {
    setContinueBtnHovered(false);
  };

  return (
    <div className="popup-bg-2">
      <div className="popup-rectangle">
        <p className={`popup-title-2 ${isSpanish ? "popup-title-2-sm" : ""}`}>
          {isSpanish ? "¡Inténtalo otra vez!" : "Try again!"}
        </p>
      </div>
      <img
        src={isContinueBtnHovered ? ContinueButtonHovered : ContinueButton}
        className="continue-btn"
        alt="Continue button"
        onClick={handleClick}
        onMouseEnter={handleContinueBtnHover}
        onMouseLeave={handleContinueBtnLeave}
      />
    </div>
  );
}

// general popup shown when user clicks on wrong answer
export function PopUp({ setShowPopup, message }) {
  const handleClick = (e) => {
    setShowPopup(false);
  };
  return (
    <div className="popup-bg-2" onClick={handleClick}>
      <div className="general-popup-rectangle">
        <p className="popup-title-3">{message}</p>
      </div>
    </div>
  );
}
